<template>
  <div class="demandReport" id="taskPlanContainer">
    <div class="leftDiv">
      <div class="leftTopDiv">
        <div class="userInfoClass">
          <div class="photo">
            <img v-if="userInfo.iconUrl" :src="userInfo.iconUrl" />
          </div>
          <div class="basicInfo">
            <tooltip-over
              :content="userInfo.username"
              :className="'username'"
              class="wid190"
              refName="username"
            ></tooltip-over>
            <div class="line"></div>
            <tooltip-over
              :content="'账号:' + userInfo.userNo"
              :className="'userNo'"
              class="wid190"
              refName="userNo"
            ></tooltip-over>
            <tooltip-over
              :content="userInfo.departmentName"
              :className="'departmentName'"
              class="wid190"
              refName="departmentName"
            ></tooltip-over>
            <tooltip-over
              :content="userInfo.roleName"
              :className="'roleName'"
              class="wid190"
              refName="roleName"
            ></tooltip-over>
          </div>
          <div class="logOut" @click="logOut()"></div>
        </div>
        <div class="statistics">
          <div
            class="waitAssessment"
            :style="opacityOfWaitAssessment"
            @click="waitAssessment"
          >
            <div class="title">待评估</div>
            <div class="num">{{ waitAssessmentNum }}</div>
          </div>
          <div class="assessment" :style="opacityOfAssessment" @click="assessment">
            <div class="title">已评估</div>
            <div class="num">{{ assessmentNum }}</div>
          </div>
        </div>
      </div>
      <div class="leftBottomDiv">
        <div class="contentClass">
          <!-- <div class="tableTitle">
            <div class="title">任务计划列表</div>
          </div> -->
          <div  class="contentTable" ref="contentTable">
            <el-table
              :data="taskPlanList"
              @row-click="clickTaskPlanRow"
              ref="taskPlanList"
              :max-height="taskPlanTableAutoHeight"
              :row-style="{ height: '40px' }"
              :cell-style="changeCellStyle"
              :row-class-name="tableRowClassName"
              style="width: 92%"
              tooltip-effect="light"
              class="taskTable"
            >
              <el-table-column
                prop="local_id"
                label="任务编号"
                min-width="80"
                :show-overflow-tooltip="true"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="mission_name"
                label="任务名称"
                align="center"
                min-width="100"
                :show-overflow-tooltip="true"
              >
              </el-table-column>
              <el-table-column
                label="优先级"
                align="center"
                min-width="55"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.priority === 1">低</span>
                  <span v-else-if="scope.row.priority === 2">中</span>
                  <span v-else-if="scope.row.priority === 3">高</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="flight_status"
                label="当前状态"
                align="center"
                min-width="55"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.mission_status === 5">待审批</span>
                  <span v-else-if="scope.row.mission_status === 8">审批拒绝</span>
                  <span v-else-if="scope.row.mission_status === 10">待取货</span>
                  <span v-else-if="scope.row.mission_status === 20">完成取货</span>
                  <span v-else-if="scope.row.mission_status === 90">任务完成</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="searchArea">
            <div class="desc">计划搜索</div>
            <div class="separate"></div>
            <el-form :model="queryForm" @submit.native.prevent>
              <el-form-item label="">
                <el-input
                  class="inputClass"
                  v-model="queryForm.mission_name"
                  @keyup.enter.native="getTaskListByMissionStatus()"
                >
                  <i
                    class="el-icon-search-img"
                    slot="suffix"
                    @click="getTaskListByMissionStatus()"
                  >
                  </i></el-input
              ></el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <div class="middleDiv" v-if="isDetail">
      <div class="middleDivTop">
        <div class="middleDivContent">
          <div class="taskInfo">
            <div class="taskTitle">
              <div class="taskIcon">
                <img :src="taskIcon" class="icon" />
              </div>
              <div class="taskInfo">
                <div class="descOfNo">
                  任务编号
                </div>
                <div class="line"></div>
                <div class="descOfNoText">
                  {{ taskDetailInfoContent.local_id }}
                </div>
              </div>
              <div class="rightCode">
                <img id="taskBarcode" class="taskBarcode" />
              </div>
            </div>

            <div>
              <div class="seperate"></div>
              <el-row class="taskPlanCreateInfo">
                  <el-col :span="12"><div class="grid-content bg-purple">
                    <div class="content">创建时间：{{ taskDetailInfoContent.created_at }}</div>
                  </div></el-col>
                  <el-col :span="12"><div class="grid-content bg-purple-light">
                      <div class="content">提交ID：{{ taskDetailInfoContent.user_no }}</div>
                  </div></el-col>
              </el-row>
              <div class="seperate"></div>
            </div>

            <div class="taskPlanDetailInfo">
              <div class="taskPlanDetailInfoTop">
                <el-row class="taskInfoTitle">
                  <el-col :span="12"><div class="grid-content bg-purple">任务名称</div></el-col>
                  <el-col :span="12"><div class="grid-content bg-purple-light">优先级</div></el-col>
                </el-row>
                <el-row class="taskInfoContent">
                  <el-col :span="12"><div class="grid-content bg-purple">{{ taskDetailInfoContent.mission_name }}</div></el-col>
                  <el-col :span="12"><div class="grid-content bg-purple-light">
                    <img :src="minimumer" alt="" v-if="taskDetailInfoContent.priority === 1">
                    <img :src="secondaryer" alt="" v-else-if="taskDetailInfoContent.priority === 2">
                    <img :src="highester" alt="" v-else-if="taskDetailInfoContent.priority === 3">
                  </div></el-col>
                </el-row>
                <el-row class="taskInfoTitle">
                  <el-col :span="12"><div class="grid-content bg-purple">预计发货时间</div></el-col>
                  <el-col :span="12"><div class="grid-content bg-purple-light">预计收货时间</div></el-col>
                </el-row>
                <el-row class="taskInfoContent">
                  <el-col :span="12"><div class="grid-content bg-purple">{{ taskDetailInfoContent.appointment_delivery_at }}</div></el-col>
                  <el-col :span="12"><div class="grid-content bg-purple-light">{{ taskDetailInfoContent.appointment_receive_at }}</div></el-col>
                </el-row>
                <el-row class="taskInfoTitle">
                  <el-col :span="12"><div class="grid-content bg-purple">实际开始时间</div></el-col>
                  <el-col :span="12"><div class="grid-content bg-purple-light">实际完成时间</div></el-col>
                </el-row>
                <el-row class="taskInfoContent">
                  <el-col :span="12"><div class="grid-content bg-purple">{{ taskDetailInfoContent.start_at }}</div></el-col>
                  <el-col :span="12"><div class="grid-content bg-purple-light">{{ taskDetailInfoContent.end_at }}</div></el-col>
                </el-row>
                <el-row class="taskInfoTitle">
                  <el-col :span="12"><div class="grid-content bg-purple">规划总距离</div></el-col>
                  <el-col :span="12"><div class="grid-content bg-purple-light">实际飞行距离</div></el-col>
                </el-row>
                <el-row class="taskInfoContent">
                  <el-col :span="12"><div class="grid-content bg-purple">{{ taskDetailInfoContent.planning_distance + ' km' }}</div></el-col>
                  <el-col :span="12"><div class="grid-content bg-purple-light">{{ taskDetailInfoContent.real_distance + ' km' }}</div></el-col>
                </el-row>
              </div>
              <div class="seperate"></div>
              <div class="taskPlanDetailInfoBottom">
                <el-row class="costTotal">
                  <el-col :span="24"><div class="grid-content bg-purple">费用总计(RMB)：{{ taskDetailInfoContent.price }}</div></el-col>
                </el-row>
                <el-row class="taskInfoTitle">
                  <el-col :span="12"><div class="grid-content bg-purple">公司名称</div></el-col>
                  <el-col :span="12"><div class="grid-content bg-purple-light">获得金额(RMB)</div></el-col>
                </el-row>
                <el-row class="taskInfoContent">
                  <el-col :span="12"><div class="grid-content bg-purple">{{ '平台方' }}</div></el-col>
                  <el-col :span="12"><div class="grid-content bg-purple-light">{{ '0.00' }}</div></el-col>
                </el-row>
                <el-row class="taskInfoTitle">
                  <el-col :span="12"><div class="grid-content bg-purple">平台载重效能</div></el-col>
                  <el-col :span="12"><div class="grid-content bg-purple-light">投送速度效能</div></el-col>
                </el-row>
                <el-row class="taskInfoContent">
                  <el-col :span="12"><div class="grid-content bg-purple">{{ '0' }}</div></el-col>
                  <el-col :span="12"><div class="grid-content bg-purple-light">{{ '0' }}</div></el-col>
                </el-row>
                <el-row class="taskInfoTitle">
                  <el-col :span="12"><div class="grid-content bg-purple">飞行准确性效能</div></el-col>
                  <el-col :span="12"><div class="grid-content bg-purple-light">单位重量单位距离时间效能</div></el-col>
                </el-row>
                <el-row class="taskInfoContent">
                  <el-col :span="12"><div class="grid-content bg-purple">{{ '0' }}</div></el-col>
                  <el-col :span="12"><div class="grid-content bg-purple-light">{{ '0' }}</div></el-col>
                </el-row>
                <el-row class="taskInfoTitle">
                  <el-col :span="12"><div class="grid-content bg-purple">单位重量单位距离费用效能</div></el-col>
                  <el-col :span="12"><div class="grid-content bg-purple-light">综合效能指标</div></el-col>
                </el-row>
                <el-row class="taskInfoContent">
                  <el-col :span="12"><div class="grid-content bg-purple">{{ '0' }}</div></el-col>
                  <el-col :span="12"><div class="grid-content bg-purple-light">{{ '0' }}</div></el-col>
                </el-row>
              </div>
              <div class="seperate"></div>
            </div>
          </div>

          <div class="goodsInfo">
            <div class="taskTitle">
              <div class="taskIcon">
                <img :src="goodsIcon" class="icon" />
              </div>
              <div class="taskInfo">
                <div class="descOfNo">
                    <span>货物名称：</span>
                    <el-tooltip
                      class="item"
                      effect="light"
                      :content="taskDetailInfoContent.goods_name"
                      placement="top"
                      :disabled="taskDetailInfoContent.goods_name.length <= 11"
                    >
                      <span> {{ taskDetailInfoContent.goods_name.length > 11 ?  taskDetailInfoContent.goods_name.slice(0, 11) + '...' : taskDetailInfoContent.goods_name}} </span>
                    </el-tooltip>
                </div>
                <div class="line"></div>
                <div class="descOfNoText">
                  <span><i class="el-icon-takeaway-box"></i>件数<span style="marginLeft: 13px">{{taskDetailInfoContent.goods_count}}</span></span>
                  <span><i class="el-icon-s-goods"></i>总重量<span  style="marginLeft: 13px">{{taskDetailInfoContent.goods_total_weight + ' KG'}}</span></span>
                </div>
              </div>
            </div>

            <div class="goodsInfoContent">
              <el-collapse>
                <el-collapse-item title="发货方信息">
                  <el-row class="taskInfoTitle">
                    <el-col :span="12"><div class="grid-content bg-purple">补堆名称</div></el-col>
                    <el-col :span="12"><div class="grid-content bg-purple-light">发货地址</div></el-col>
                  </el-row>
                  <el-row class="taskInfoContent">
                    <el-col :span="12">
                      <el-tooltip
                        class="item"
                        effect="light"
                        :content="taskDetailInfoContent.customer_company"
                        placement="top"
                        :disabled="taskDetailInfoContent.customer_company.length <= 14"
                      >
                        <div class="grid-content bg-purple">
                          {{ taskDetailInfoContent.customer_company.length > 14 ? taskDetailInfoContent.customer_company.slice(0, 14) + '...' :  taskDetailInfoContent.customer_company }}
                        </div>
                      </el-tooltip>
                    </el-col>
                    <el-col :span="12">
                      <el-tooltip
                        class="item"
                        effect="light"
                        :content="taskDetailInfoContent.customer_address"
                        placement="top"
                        :disabled="taskDetailInfoContent.customer_address.length <= 14"
                      >
                        <div class="grid-content bg-purple">
                          {{ taskDetailInfoContent.customer_address.length > 14 ? taskDetailInfoContent.customer_address.slice(0, 14) + '...' :  taskDetailInfoContent.customer_address }}
                        </div>
                      </el-tooltip>
                    </el-col>
                  </el-row>
                  <el-row class="taskInfoTitle">
                    <el-col :span="12"><div class="grid-content bg-purple">发货战区</div></el-col>
                    <el-col :span="12"><div class="grid-content bg-purple-light">联系人</div></el-col>
                  </el-row>
                  <el-row class="taskInfoContent">
                    <el-col :span="12">
                      <el-tooltip
                        class="item"
                        effect="light"
                        :content="(taskDetailInfoContent.area_name + '/' + taskDetailInfoContent.station_name)"
                        placement="top"
                        :disabled="(taskDetailInfoContent.area_name + '/' + taskDetailInfoContent.station_name).length <= 14"
                      >
                        <div class="grid-content bg-purple">
                          {{ (taskDetailInfoContent.area_name + '/' + taskDetailInfoContent.station_name).length > 14 ? (taskDetailInfoContent.area_name + '/' + taskDetailInfoContent.station_name).slice(0, 14) + '...' :  (taskDetailInfoContent.area_name + '/' + taskDetailInfoContent.station_name) }}
                        </div>
                      </el-tooltip>
                    </el-col>
                    <el-col :span="12">
                      <el-tooltip
                        class="item"
                        effect="light"
                        :content="taskDetailInfoContent.customer_name"
                        placement="top"
                        :disabled="taskDetailInfoContent.customer_name.length <= 14"
                      >
                        <div class="grid-content bg-purple">
                          {{ taskDetailInfoContent.customer_name.length > 14 ? taskDetailInfoContent.customer_name.slice(0, 14) + '...' :  taskDetailInfoContent.customer_name }}
                        </div>
                      </el-tooltip>
                    </el-col>
                  </el-row>
                  <el-row class="taskInfoTitle">
                    <el-col :span="12"><div class="grid-content bg-purple">联系方式</div></el-col>
                    <el-col :span="12"><div class="grid-content bg-purple-light"></div></el-col>
                  </el-row>
                  <el-row class="taskInfoContent">
                    <el-col :span="12"><div class="grid-content bg-purple">{{ taskDetailInfoContent.customer_phone }}</div></el-col>
                    <el-col :span="12"><div class="grid-content bg-purple-light"></div></el-col>
                  </el-row>
                </el-collapse-item>
                <el-collapse-item title="收货方信息">
                  <el-row class="taskInfoTitle">
                    <el-col :span="12"><div class="grid-content bg-purple">补堆名称</div></el-col>
                    <el-col :span="12"><div class="grid-content bg-purple-light">收货地址</div></el-col>
                  </el-row>
                  <el-row class="taskInfoContent">
                    <el-col :span="12">
                      <el-tooltip
                        class="item"
                        effect="light"
                        :content="taskDetailInfoContent.destination_company"
                        placement="top"
                        :disabled="taskDetailInfoContent.destination_company.length <= 14"
                      >
                        <div class="grid-content bg-purple">
                          {{ taskDetailInfoContent.destination_company.length > 14 ? taskDetailInfoContent.destination_company.slice(0, 14) + '...' :  taskDetailInfoContent.destination_company }}
                        </div>
                      </el-tooltip>
                    </el-col>
                    <el-col :span="12">
                      <el-tooltip
                        class="item"
                        effect="light"
                        :content="taskDetailInfoContent.destination_address"
                        placement="top"
                        :disabled="taskDetailInfoContent.destination_address.length <= 14"
                      >
                        <div class="grid-content bg-purple">
                          {{ taskDetailInfoContent.destination_address.length > 14 ? taskDetailInfoContent.destination_address.slice(0, 14) + '...' :  taskDetailInfoContent.destination_address }}
                        </div>
                      </el-tooltip>
                    </el-col>
                  </el-row>
                  <el-row class="taskInfoTitle">
                    <el-col :span="12"><div class="grid-content bg-purple">联系人</div></el-col>
                    <el-col :span="12"><div class="grid-content bg-purple-light">联系方式</div></el-col>
                  </el-row>
                  <el-row class="taskInfoContent">
                    <el-col :span="12">
                       <el-tooltip
                        class="item"
                        effect="light"
                        :content="taskDetailInfoContent.destination_name"
                        placement="top"
                        :disabled="taskDetailInfoContent.destination_name.length <= 14"
                      >
                        <div class="grid-content bg-purple">
                          {{ taskDetailInfoContent.destination_name.length > 14 ? taskDetailInfoContent.destination_name.slice(0, 14) + '...' :  taskDetailInfoContent.destination_name }}
                        </div>
                      </el-tooltip>
                    </el-col>
                    <el-col :span="12"><div class="grid-content bg-purple-light">{{ taskDetailInfoContent.destination_phone }}</div></el-col>
                  </el-row>
                </el-collapse-item>
                <el-collapse-item title="需要取货" v-if="taskDetailInfoContent.need_take_delivery === 1">
                  <el-row class="taskInfoTitle">
                    <el-col :span="12"><div class="grid-content bg-purple">取货人员</div></el-col>
                    <el-col :span="12"><div class="grid-content bg-purple-light">联系方式</div></el-col>
                  </el-row>
                  <el-row class="taskInfoContent">
                    <el-col :span="12">
                       <el-tooltip
                        class="item"
                        effect="light"
                        :content="taskDetailInfoContent.receiver_name"
                        placement="top"
                        :disabled="taskDetailInfoContent.receiver_name.length <= 14"
                      >
                        <div class="grid-content bg-purple">
                          {{ taskDetailInfoContent.receiver_name.length > 14 ? taskDetailInfoContent.receiver_name.slice(0, 14) + '...' :  taskDetailInfoContent.receiver_name }}
                        </div>
                      </el-tooltip>
                    </el-col>
                    <el-col :span="12"><div class="grid-content bg-purple-light">{{ taskDetailInfoContent.receiver_phone }}</div></el-col>
                  </el-row>
                  <el-row class="taskInfoTitle">
                    <el-col :span="12"><div class="grid-content bg-purple">送货时间</div></el-col>
                    <el-col :span="12"><div class="grid-content bg-purple-light"></div></el-col>
                  </el-row>
                  <el-row class="taskInfoContent">
                    <el-col :span="12"><div class="grid-content bg-purple">{{ taskDetailInfoContent.receiver_at }}</div></el-col>
                    <el-col :span="12"><div class="grid-content bg-purple-light"></div></el-col>
                  </el-row>
                </el-collapse-item>
              </el-collapse>
            </div>
          </div>
        </div>
      </div>
      
      <div class="okbutton" @click="okHandler(taskDetailInfoContent.id)" v-if="openTab === 'waitAssessment'">确定</div>
    </div>
    <div class="rightDiv" v-if="isDetail">
      <div class="rightDivContent">
        <div class="planNumberList" v-for="(item, index) in taskDetailInfoContent.flights" :key="index">
          <div class="taskTitle">
            <div class="taskIcon">
              <img :src="taskIcon" class="icon" />
            </div>
            <div class="taskInfo">
              <div class="descOfNo">
                计划编号
              </div>
              <div class="line"></div>
              <div class="descOfNoText">
                {{ item.local_id}}
              </div>
            </div>
            <div class="rightCode">
              <img :src="minimumer" alt="" v-if="item.priority === 1">
              <img :src="secondaryer" alt="" v-else-if="item.priority === 2">
              <img :src="highester" alt="" v-else-if="item.priority === 3">
            </div>
          </div>

          <div>
            <div class="seperate"></div>
            <el-row class="taskPlanCreateInfo">
                <el-col :span="9"><div class="grid-content bg-purple">
                  <div class="content">创建时间：{{ item.created_at }}</div>
                </div></el-col>
                <el-col :span="8"><div class="grid-content bg-purple-light">
                    <div class="content">计划状态：
                      <span v-if="item.flight_status === 10">规划中</span>
                      <span v-else-if="item.flight_status === 15">已提交/待环境确认</span>
                      <span v-else-if="item.flight_status === 20">待审核</span>
                      <span v-else-if="item.flight_status === 30">环境保障驳回</span>
                      <span v-else-if="item.flight_status === 31">审批拒绝</span>
                      <span v-else-if="item.flight_status === 40">审核通过</span>
                      <span v-else-if="item.flight_status === 50">待飞行</span>
                      <span v-else-if="item.flight_status === 60">正在飞行</span>
                      <span v-else-if="item.flight_status === 70">飞行结束</span>
                      <span v-else-if="item.flight_status === 90">确认收货</span>
                    </div>
                </div></el-col>
                <el-col :span="7"><div class="grid-content bg-purple" v-if="item.flight_status === 90">
                  <div class="playBackContent" @click="showFlightDetail(item.id)"><span class="playBack">回放<span class="el-icon-play"></span></span></div>
                </div></el-col>
            </el-row>
            <div class="seperate"></div>
          </div>

          <div class="planTimeInfo">
            <el-collapse>
              <el-collapse-item>
                <template slot="title">
                  <i class="header-icon el-icon-remark" style="marginRight: 9px"></i>计划详情
                </template>
                <el-row class="taskPlanCreateInfo">
                  <el-col :span="12">
                    <div class="grid-content bg-purple">
                      <span class="title">开始时间</span>
                      <span class="content">{{ item.start_at }}</span>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="grid-content bg-purple-light">
                      <span class="title">结束时间</span>
                      <span class="content">{{ item.end_at }}</span>
                    </div>
                  </el-col>
                </el-row>
                <el-row class="taskPlanCreateInfo">
                  <el-col :span="12">
                    <div class="grid-content bg-purple">
                      <span class="title">实际开始时间</span>
                      <span class="content">{{ item.real_start_at }}</span>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="grid-content bg-purple-light">
                      <span class="title">实际结束时间</span>
                      <span class="content">{{ item.real_end_at }}</span>
                    </div>
                  </el-col>
                </el-row>
                <el-row class="taskPlanCreateInfo">
                  <el-col :span="12">
                    <div class="grid-content bg-purple">
                      <span class="title">计划飞行时间</span>
                      <span class="content">{{ item.plan_time + ' min' }}</span>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="grid-content bg-purple-light">
                      <span class="title">计划飞行速度</span>
                      <span class="content">{{ item.flight_speed }}</span>
                    </div>
                  </el-col>
                </el-row>
                <el-row class="taskPlanCreateInfo">
                  <el-col :span="12">
                    <div class="grid-content bg-purple">
                      <span class="title">实际飞行时间</span>
                      <span class="content">{{ item.real_time + ' min' }}</span>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="grid-content bg-purple-light">
                      <span class="title">实际飞行速度</span>
                      <span class="content">{{ item.real_speed }}</span>
                    </div>
                  </el-col>
                </el-row>
                <el-row class="taskPlanCreateInfo">
                  <el-col :span="12">
                    <div class="grid-content bg-purple">
                      <span class="title">规划距离</span>
                      <span class="content">{{ item.total_mileage + ' km' }}</span>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="grid-content bg-purple-light">
                      <span class="title">实际距离</span>
                      <span class="content">{{ item.real_distance + ' km' }}</span>
                    </div>
                  </el-col>
                </el-row>
                <el-row class="taskPlanCreateInfo">
                  <el-col :span="12">
                    <div class="grid-content bg-purple">
                      <span class="title">平台载重效能</span>
                      <span class="content">{{ '0' }}</span>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="grid-content bg-purple-light">
                      <span class="title">投送速度效能</span>
                      <span class="content">{{ '0' }}</span>
                    </div>
                  </el-col>
                </el-row>
                <el-row class="taskPlanCreateInfo">
                  <el-col :span="12">
                    <div class="grid-content bg-purple">
                      <span class="title">飞行准确性效能</span>
                      <span class="content">{{ '0' }}</span>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="grid-content bg-purple-light">
                      <span class="title" style="width: 190px">单位重量单位距离费用效能</span>
                      <span class="content">{{ '0' }}</span>
                    </div>
                  </el-col>
                </el-row>
                <el-row class="taskPlanCreateInfo">
                  <el-col :span="12">
                    <div class="grid-content bg-purple">
                      <span class="title"  style="width: 190px">单位重量单位距离时间效能</span>
                      <span class="content">{{ '0' }}</span>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="grid-content bg-purple-light">
                      <span class="title">综合效能指标</span>
                      <span class="content">{{ '0' }}</span>
                    </div>
                  </el-col>
                </el-row>
              </el-collapse-item>
            </el-collapse>
          </div>

          <div class="goodsInfo">
            <div class="goodsInfoListContent">
              <el-checkbox-group v-model="checkedItem[index]" >
                <div class="goodsCodeInfo" v-for="(goodsItem, goodsIndex) in item.goods" :key="goodsItem.local_id" >
                  <div class="goodsCodeInfoLeft">
                    <div class="title">货物编号</div>
                    <div class="content">{{ goodsItem.local_id }}</div>
                  </div>
                  <div class="goodsCodeInfoRight">
                    <el-checkbox :label="goodsItem.local_id" @change="checkedGoodsCodeHandler(goodsItem.local_id, goodsIndex, index, $event)">{{''}}</el-checkbox>
                  </div>
                </div>
              </el-checkbox-group>
            </div>

            <div class="goodsCodeInfoContent" v-if="checkedItem[index][0]">
              <el-row class="taskPlanCreateInfo">
                <el-col :span="12">
                  <div class="grid-content bg-purple">
                    <span class="title">体积</span>
                    <span class="content">
                      {{ 
                        item.goods[checkedItemIndex[index]].goods_length
                        + '*' + 
                        item.goods[checkedItemIndex[index]].goods_width
                        + '*' + 
                        item.goods[checkedItemIndex[index]].goods_height
                        + '/cm'
                      }}
                    </span>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content bg-purple-light">
                    <span class="title" style="width: 71px">重量</span>
                    <span class="content">{{  item.goods[checkedItemIndex[index]].goods_weight + '/kg' }}</span>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content bg-purple-light">
                    <span class="title">包装</span>
                    <span class="content">{{ item.goods[checkedItemIndex[index]].goods_package_name }}</span>
                  </div>
                </el-col>
              </el-row>
              <el-row class="taskPlanCreateInfo">
                <el-col :span="12">
                  <div class="grid-content bg-purple">
                    <span class="title">属性</span>
                    <span class="content">
                      {{
                        ((item.goods[checkedItemIndex[index]].goods_attribute_id === 1 ? '易碎性,' : '')
                        + (item.goods[checkedItemIndex[index]].goods_explosible_id === 1 ? '易爆性,' : '')
                        + (item.goods[checkedItemIndex[index]].goods_inflammable_id === 1 ? '易燃性,' : '')
                        + (item.goods[checkedItemIndex[index]].goods_cautery_id === 1 ? '腐蚀性,' : '')).slice(0, -1)
                      }}
                    </span>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content bg-purple-light">
                    <span class="title"  style="width: 71px">货物类型</span>
                    <span class="content">{{ item.goods[checkedItemIndex[index]].goods_type_name }}</span>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content bg-purple-light">
                    <span class="title">密级</span>
                    <span class="content">
                      <span v-if="item.goods[checkedItemIndex[index]].goods_secrecy_id === 0">非<span>密</span></span>
                      <span v-else-if="item.goods[checkedItemIndex[index]].goods_secrecy_id === 1">秘<span>密</span></span>
                      <span v-else-if="item.goods[checkedItemIndex[index]].goods_secrecy_id === 2">机<span>密</span></span>
                      <span v-else-if="item.goods[checkedItemIndex[index]].goods_secrecy_id === 3">绝<span>密</span></span>
                    </span>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import taskIcon from "@/assets/img/home/task.png";
import goodsIcon from "@/assets/img/home/goods.png";

import minimumer from "@/assets/img/home/minimumer.png";
import secondaryer from "@/assets/img/home/secondaryer.png";
import highester from "@/assets/img/home/highester.png";

import tooltipOver from "../tools/tooltipOver";
import { deepCopy } from '../../utils/tools'
import JsBarcode from "jsbarcode";

export default {
  name: "MissionAssessment",
  props: ["userInfo"],
  components: {
    "tooltip-over": tooltipOver,
  },
  data() {
    return {
      // 注册图片
      taskIcon,
      goodsIcon,
      minimumer,
      secondaryer,
      highester,

      // 定义左侧表格初始高度
      taskPlanTableAutoHeight: 200,
      // 用来存储浏览器高度
      windowHeight: 0,
      // 绑定右侧计划编号货物选中数据
      checkedItem: [[]],
      // 绑定右侧计划编号货物选中数据index
      checkedItemIndex: [],
      
      waitAssessmentNum: 0,
      assessmentNum: 0,

      opacityOfWaitAssessment: "opacity: 1;",
      opacityOfAssessment: "opacity: 0.4;",
      openTab: "waitAssessment",

      // 是否是查看详情
      isDetail: false,
      // 左侧表格查询参数
      queryForm: {
        mission_status: 20, // 20为待评估，90为已评估
        surplus_goods_count: 0, // 待评估查询时加个参数surplus_goods_count=0
        mission_name: "", // 搜索字段内容
        currentpage: 1,
        pagesize: 0,
        is_removed: 0
      },

      // 左侧任务列表数据
      taskPlanList: [],
      // 右侧任务详情信息
      taskDetailInfoContent: {},
      //货物列表信息
      goodsList: [], 

      openedId: null, //已展开的任务
    };
  },
  methods: {
    // 待评估事件
    waitAssessment() {
      if (this.openTab !== "waitAssessment") {
        this.opacityOfWaitAssessment = "opacity: 1;";
        this.opacityOfAssessment = "opacity: 0.4;";
        this.openedId = null;
        this.isDetail = false;
        this.queryForm.mission_status = 20;
        this.queryForm.surplus_goods_count = 0;
        this.getTaskListByMissionStatus();
      }
      this.openTab = "waitAssessment";
    },
    // 已评估事件
    assessment() {
      if (this.openTab !== "assessment") {
        this.opacityOfWaitAssessment = "opacity: 0.4;";
        this.opacityOfAssessment = "opacity: 1;";
        this.openedId = null;
        this.isDetail = false;
        this.queryForm.mission_status = 90;
        delete this.queryForm.surplus_goods_count
        this.getTaskListByMissionStatus();
      }
      this.openTab = "assessment";
    },
    // 查询待评估、已评估 任务数量
    getMissionAccessStatics() {
      this.getRequest(
        "/uav-task-server/mission/getMissionAccessStatics.do"
      ).then((res) => {
        let oData = res.data;
        if (oData.code == 0) {
          let data = oData.data;
          if (data) {
            this.waitAssessmentNum = data.waitingForAssess;
            this.assessmentNum = data.finished;
          } else {
            this.waitAssessmentNum = 0;
            this.assessmentNum = 0;
          }
        } else if (oData.code != 401) {
          let tips = "<i class='el-icon-warn-tip'></i>啊哦,任务统计获取失败~";
          this.$confirm(tips, "提示", {
            confirmButtonText: "好的",
            customClass: "confirmClass-style",
            iconClass: "",
            confirmButtonClass: "confirm",
            dangerouslyUseHTMLString: true,
            showCancelButton: false,
          });
        }
      });
    },
    // 查询待评估、已评估 任务列表
    getTaskListByMissionStatus() {
      const param = this.getQueryParam(deepCopy(this.queryForm));
      this.getRequest(
        "/uav-task-server/mission/getMissionList.do?" +
          param
      ).then((res) => {
        let oData = res.data;
        if (0 == oData.code) {
          let data = oData.data;
          if (data) {
            this.taskPlanList = deepCopy(data.list);
          } else {
            this.taskPlanList = [];
          }
        } else if (oData.code != 401) {
          let tips =
            "<i class='el-icon-warn-tip'></i>啊哦,任务列表获取失败~";
          this.$confirm(tips, "提示", {
            confirmButtonText: "好的",
            customClass: "confirmClass-style",
            iconClass: "",
            confirmButtonClass: "confirm",
            dangerouslyUseHTMLString: true,
            showCancelButton: false,
          });
        }
      });
    },
    // 点击左侧表格任务触发的事件
    clickTaskPlanRow(row) {
      if (this.openedId !== row.id) {
        this.openedId = row.id;
        this.queryFlight(row.id);
      }
    },
    // 根据id获取任务信息
    queryFlight(id) {
      this.getRequest("/uav-task-server/mission/getMissionForAssess.do?missionId=" + id)
      .then((res) => {
          let oData = res.data;
          if (oData.code == 0) {
            let data = oData.data;
            if (data) {
              // console.log(deepCopy(data))

              this.taskDetailInfoContent = deepCopy(data)
              // 初始化右侧货物列表选择框数组
              this.checkedItem = Array(this.taskDetailInfoContent.flights.length).fill([], 0)
              if(!this.isDetail) this.isDetail = true
              this.$nextTick(() => {
                this.createBarcode(this.taskDetailInfoContent.local_id);
              })
            }
          } else if (oData.code != 401) {
            let tips = "<i class='el-icon-warn-tip'></i>啊哦,任务信息获取失败~";
            this.$confirm(tips, "提示", {
              confirmButtonText: "好的",
              customClass: "confirmClass-style",
              iconClass: "",
              confirmButtonClass: "confirm",
              dangerouslyUseHTMLString: true,
              showCancelButton: false,
            });
          }
        }
      );
    },
    // 生成条形码
    createBarcode(taskLocalId) {
      JsBarcode("#taskBarcode", taskLocalId, {
        format: "CODE39", //条形码的格式
        lineColor: "#ffffff", //线条颜色
        width: 1, // 线宽
        height: 25, // 条码高度
        displayValue: true, //是否在条形码下方显示文字
        background: "transparent", //背景色
        font: "ArialMT", //设置文本的字体
        textMargin: 9, //设置条形码和文本之间的间距
        fontSize: "14", //设置文本的大小
        margin: 10, //设置条形码周围的空白边距
      });
    },

    // 左侧表格优先级文字颜色
    changeCellStyle(row) {
      if (row.column.label === "优先级") {
        return "color:#FFA63E;padding: 0;"; //修改的样式
      } else {
        return "color:#FFFFFF;padding: 0;";
      }
    },
    // 左侧表格样式
    tableRowClassName({ row, rowIndex }) {
      if (this.openedId === row.id) {
        return "focusRowStyle";
      }
      return "rowStyle";
    },

    // 提交评估处理事件
    okHandler(id) {
      let tips = "<i class='el-icon-warn-tip'></i>确定评估该任务?";
      this.$confirm(tips, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "confirmClass-style",
        iconClass: "",
        confirmButtonClass: "confirm",
        dangerouslyUseHTMLString: true,
        cancelButtonClass: "cancel",
      }).then(() => {
        this.postJsonRequest(
            "/uav-task-server/mission/assessMission.do",
            {id}
        ).then(res => {
          console.log(res)
          if (res.data.code === 0) {
            this.$message({
              message: '已完成此任务评估！',
              type: 'success',
              duration: 3000
            });
            this.isDetail = false
            this.getMissionAccessStatics();
            this.getTaskListByMissionStatus();
          } else {
            let failTips = "<i class='el-icon-warn-tip'></i>评估失败，此任务存在未完成的计划!";
            this.$alert(failTips, "提示", {
              customClass: "confirmClass-style",
              confirmButtonText: "确定",
              confirmButtonClass: "confirm",
              dangerouslyUseHTMLString: true,
              showClose: false
            })
          }
        })
      }).catch(res => {
        this.$message({
          message: '已取消此任务评估！',
          duration: 1000
        });
      })
    },

    // 点击右侧货物编号复选框的处理事件
    checkedGoodsCodeHandler(goodsCode,goodsIndex,planIndex, e) {
      if (e) {
        this.checkedItem[planIndex] = [goodsCode]
        this.checkedItemIndex[planIndex] = goodsIndex
      } else {
        this.checkedItem[planIndex] = []
      }
    },

    // 浏览器窗口大小变化监听绑定的事件 -- 屏幕自适应
    eventListenerWindowSize() {
      return (() => {
        this.windowHeight = document.body.clientHeight;
      })()
    },

    // 显示回放页面
    showFlightDetail(id) {
      this.$emit("showFlightDetail", { 
        show: true, 
        id,
        componentName: 'missionAssessment'
        });
    }
  },

  mounted() {
    this.getMissionAccessStatics();
    this.$nextTick(function () {
      this.getTaskListByMissionStatus();
    });
    window.statisicsTimer = setInterval(
      this.getMissionAccessStatics,
      28000
    ); //28秒轮询一次
    window.queryTimer = setInterval(
      this.getTaskListByMissionStatus,
      30000
    ); //30秒轮询一次

    // 添加浏览器窗口大小变化监听事件 -- 屏幕自适应
    window.addEventListener("resize", this.eventListenerWindowSize);
  },
  beforeDestroy() {
    if (window.statisicsTimer) {
      clearInterval(window.statisicsTimer);
      window.statisicsTimer = null;
    }
    if (window.queryTimer) {
      clearInterval(window.queryTimer);
      window.queryTimer = null;
    }

    // 移除浏览器窗口大小变化监听事件 -- 屏幕自适应
    window.removeEventListener("resize", this.eventListenerWindowSize);
  },
  watch: {
    // 监听浏览器窗口大小变化 -- 屏幕自适应
    windowHeight: {
      handler() {
        // 540为除this.$refs.contentTable.offsetHeight高度之外的高度（浏览器高度 - this.$refs.contentTable.offsetHeight 的高度）
        // 15为表格的margin-top（15px）
        this.taskPlanTableAutoHeight = document.body.clientHeight - 540 - 15;
      },
      immediate: true,
      deep: true
    }
  }
};
</script>

<style scoped>
@import "../../assets/css/home/MissionAssessment.css";
</style>

<style>
  .middleDiv .middleDivContent .goodsInfo .goodsInfoContent .el-collapse,
  .planTimeInfo .el-collapse{
    border: none;
  }
  .middleDiv .middleDivContent .goodsInfo .goodsInfoContent .el-collapse-item__header,
  .middleDiv .middleDivContent .goodsInfo .goodsInfoContent .is-active .el-collapse-item__header{
    height: 32px;
    padding-left: 10px;
    border-radius: 3px;
    background: #0083FD;
    border: 0;
    color: #fff;
    font-size: 14px;
    margin-bottom: 2px;
    font-family: AlibabaPuHuiTiM;
  }
  .middleDiv .middleDivContent .goodsInfo .goodsInfoContent .el-collapse-item:nth-of-type(2) .el-collapse-item__header,
  .middleDiv .middleDivContent .goodsInfo .goodsInfoContent .el-collapse-item:nth-of-type(2) .is-active .el-collapse-item__header{
    background: #FFA63E;
  }
  
  .planTimeInfo .el-collapse-item__header{
    height: 32px;
    padding-left: 10px;
    border-radius: 3px;
    background: rgba(0, 131, 253, 0.1);
    border: 1px solid #146BF9 !important;
    border: 0;
    color: #fff;
    font-size: 14px;
    margin-bottom: 5px;
    font-family: AlibabaPuHuiTiM;
  }

  .planTimeInfo .is-active .el-collapse-item__header{
    background: #146BF9;
  }

  .middleDiv .middleDivContent .goodsInfo .goodsInfoContent .el-collapse-item__wrap,
  .planTimeInfo .el-collapse-item__wrap{
    background: transparent;
    border: 0;
  }

  .goodsInfoContent .el-icon-arrow-right,
  .planTimeInfo .el-icon-arrow-right {
    background: url("../../assets/img/taskPlan/rightArrow.png") no-repeat;
    width: 6px;
    height: 9px;
    margin: 0 12px 0 auto;
  }
  .goodsInfoContent .el-icon-arrow-right.is-active,
  .planTimeInfo .el-icon-arrow-right.is-active {
    background: url("../../assets/img/taskPlan/bottomArrow.png") no-repeat;
    transform: none;
    width: 8px;
    height: 6px;
  }
  .goodsInfoContent .el-icon-arrow-right:before,
  .planTimeInfo .el-icon-arrow-right:before {
    content: "";
  }

  .rightDiv .planNumberList .goodsInfo .goodsCodeInfo .goodsCodeInfoRight .el-checkbox__inner {
    width: 22px;
    height: 22px;
    background: rgba(0, 131, 253, 0.1);
    border: 1px solid #0083FD;
    border-radius: 3px;
  }
  .rightDiv .planNumberList .goodsInfo .goodsCodeInfo .goodsCodeInfoRight .el-checkbox__inner::after {
    height: 10px;
    width: 4px;
    left: 8px;
    top: 3px;
  }

  .el-message--success {
    background: #1C2340;
    border: 1px solid #146BF9;
    box-shadow: 0px 3px 9px 0px rgba(0, 0, 0, 0.41);
    border-radius: 6px;
  }

  .el-message--success .el-message__content {
    color: #146BF9;
    font-size: 14px;
    font-family: AlibabaPuHuiTiM;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/missionAssessment.vue